import { fetchApi } from '../client';

export interface RazorpayOrderResponse {
  orderId: string;
  amountPaise: number;
  currency: string;
  keyId: string;
}

export interface PaymentVerifyRequest {
  razorpayOrderId: string;
  razorpayPaymentId: string;
  razorpaySignature: string;
}

export interface RazorpayStatus {
  configured: boolean;
  keyId: string;
}

export const paymentsModule = {
  getStatus: () =>
    fetchApi<RazorpayStatus>('/api/payments/razorpay/status'),

  createOrder: (billId: string) =>
    fetchApi<RazorpayOrderResponse>('/api/payments/razorpay/orders', {
      method: 'POST',
      body: JSON.stringify({ billId }),
    }),

  verifyPayment: (payload: PaymentVerifyRequest) =>
    fetchApi<{ message: string }>('/api/payments/razorpay/verify', {
      method: 'POST',
      body: JSON.stringify(payload),
    }),
};
